import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Baby } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const StudentAvatar = ({ photoId, name, size = 'md', testId = 'student-avatar' }) => {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let localUrl = null;
    if (!photoId) { setBlobUrl(null); return () => {}; }
    axios
      .get(`${API}/api/files/${photoId}`, { withCredentials: true, responseType: 'blob' })
      .then((res) => {
        if (cancelled) return;
        localUrl = URL.createObjectURL(res.data);
        setBlobUrl(localUrl);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (localUrl) URL.revokeObjectURL(localUrl);
    };
  }, [photoId]);

  const sizeClass = size === 'lg' ? 'w-20 h-20' : size === 'sm' ? 'w-10 h-10' : 'w-14 h-14';
  const iconSize = size === 'lg' ? 'w-10 h-10' : size === 'sm' ? 'w-5 h-5' : 'w-7 h-7';

  if (blobUrl) {
    return (
      <img
        src={blobUrl}
        alt={name || 'Student'}
        className={`${sizeClass} rounded-full object-cover border-2 border-blue-100`}
        data-testid={testId}
      />
    );
  }

  return (
    <div className={`${sizeClass} bg-blue-100 rounded-full flex items-center justify-center`} data-testid={testId}>
      <Baby className={`${iconSize} text-blue-600`} />
    </div>
  );
};

export default StudentAvatar;
